{{date | date: format}}
<div class="small opacity-75" *ngIf="date && fromNow"> {{date | fromNow}} </div>
